import * as React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

export default function AddDialog(props) {
    const { onSave, onClose, open } = props;

    const [vehicleId, setVehicleId] = React.useState("");
    const [vendorId, setVendorId] = React.useState("");
    const [vehicleNo, setVehicleNo] = React.useState("");
    const [vehicleType, setVehicleType] = React.useState("");
    const [locationName, setLocationName] = React.useState("");
    const [locationLat, setLocationLat] = React.useState("");
    const [locationLng, setLocationLng] = React.useState("");
    const [capacity, setCapacity] = React.useState("");

    const handleClose = () => {
        onClose();
    };

    const handleSave = () => {
        onSave({
            vehicle_id: vehicleId,
            vendor_id: vendorId,
            vehicle_no: vehicleNo,
            vehicle_type: vehicleType,
            location: {
                name: locationName,
                lat: parseFloat(locationLat),
                lng: parseFloat(locationLng)
            },
            capacity: parseInt(capacity),
            status: "available"
        });
    }

    return (
        <Dialog onClose={handleClose} open={open}>
            <DialogTitle>{`Add new vehicle`}</DialogTitle>
            <Box
                // component="form"
                sx={{
                    '& .MuiTextField-root': { m: 1, width: '25ch' },
                }}
                noValidate
                autoComplete="off"
                style={{ padding: '0 24px' }}
            >
                <TextField
                    id="vehicle-id"
                    label="Vehicle Id"
                    value={vehicleId}
                    onChange={(e) => setVehicleId(e.target.value)}
                />
                <TextField
                    id="vendor-id"
                    label="Vendor Id"
                    value={vendorId}
                    onChange={(e) => setVendorId(e.target.value)}
                />
                <TextField
                    id="vehicle-no"
                    label="Vehicle No."
                    value={vehicleNo}
                    onChange={(e) => setVehicleNo(e.target.value)}
                />
                <TextField
                    id="vehicle-type"
                    label="Vehicle Type"
                    value={vehicleType}
                    onChange={(e) => setVehicleType(e.target.value)}
                />
                <TextField
                    id="location-name"
                    label="Location Name"
                    value={locationName}
                    onChange={(e) => setLocationName(e.target.value)}
                />
                <TextField
                    id="location-lat"
                    label="Location Latitude"
                    value={locationLat}
                    onChange={(e) => setLocationLat(e.target.value)}
                />
                <TextField
                    id="location-lng"
                    label="Location Longitude"
                    value={locationLng}
                    onChange={(e) => setLocationLng(e.target.value)}
                />
                <TextField
                    id="capacity"
                    label="Capacity"
                    value={capacity}
                    onChange={(e) => setCapacity(e.target.value)}
                />
                <div style={{ margin: '10px', float: 'right' }}>
                    <button className="btn btn-primary success" style={{ marginRight: '10px' }} onClick={handleSave}>Save</button>
                    <button className="btn btn-primary success" onClick={() => handleClose()}>Cancel</button>
                </div>
            </Box>
        </Dialog>
    );
}
